import { registryApi, walterApi, prognoseApi, treeviaGateway } from '../clients/AxiosClients'
// import allClassificaoSitio from "../responses/classificacaoSitio/allClassificacaoSitio.json"
// import parcelasFiltradas from "../responses/classificacaoSitio/parcelasFiltradas.json"
// import modelosVariaveis from "../requests/mock/modeloVariavel.json"
// import bodyModelChosen from "./mock/ParcelasHistograma.json"

/**
 *
 * @returns Prognose dado o seu Id
 */
const getPrognosePorId = async (id) => {
	return treeviaGateway.get(`/ms-prognoses/prognose/buscar-prognose/${id}`)
}

// /**
//  *
//  * @returns dados do planejamento de uma prognose dado seu Id
//  */
// const getPlanejamentoPrognose = async id => {
//     return registryApi.get(`/Prognose/GetPrognosePlanejamento?id=${id}`);
// }

/**
 * Retorna todos Prognose cadastradas no banco de dados para popular a grid
//  */
const getAllPrognose = async () => {
	return treeviaGateway.get('/ms-prognoses/prognose/listar')
	// return allPrognose;
}

/**
 * Salva o planejamento da prognose
 */
export const salvarPlanejamento = async (body) => {
	return treeviaGateway.post(
		'/ms-prognoses/prognose/escolher-modelo-para-cada-variavel-de-interesse',
		body,
	)
}

/**
 * Render sob demanda dos gráficos do modelo (datasets grandes >10k): o back gera as
 * imagens (R/ggplot2) a partir do parquet e devolve as URLs.
 */
export const renderizarGraficosModelo = async (body, config = {}) => {
	return treeviaGateway.post(
		'/ms-prognoses/prognoseprocessamento/renderizar-graficos',
		body,
		config,
	)
}

/**
 * Render em lote (prefetch) de todos os modelos de uma variável. O back renderiza em
 * paralelo limitado e devolve as URLs por parquet. Usado pelo front para pré-carregar
 * os gráficos ao trocar de variável (navegação instantânea).
 */
export const renderizarGraficosModeloPorVariavel = async (body) => {
	return treeviaGateway.post(
		'/ms-prognoses/prognoseprocessamento/renderizar-graficos-variavel',
		body,
	)
}

/**
 * Cadastrar nova classificação de sítio no banco de dados
 * @param {Object} body Classificação de Sítio que será cadastrada
//  */
// const createClassificacaoSitio = async (body) => {
//     return classificacaoSitioApi.post('/Registry/', body)
// }

/**
 * Atualiza Classificação de Sítio no banco de dados
 * @param {Object} body Classificação de Sítio que será atualizada
//  */
// const updateClassificacaoSitio = async (body) => {
//     return registryApi.put('/ClassificacaoSitio/', body)
// }

/**
 * Lista dos ids de Classificação de Sítio que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Classificação de Sítio
 */
const deletePrognoseByIdList = async (data) => {
	return treeviaGateway.delete('/ms-prognoses/prognose/excluir', { data })
}

/**
 *
 * @param {Object} filtros Várias listas de filtros
 *
 * Filtros inicialmente suportados:
 *
 * • Lista de Estratos
 * • Lista de Data de Plantio
 * • Lista de Idade do Plantio
 * • Lista de Material Genético
 * • Lista de Espécie
 * • Lista de Data de Medição
 * • Lista de Fazenda
 * • Lista de Espaçamento
 * • Lista de Variável Customizadas
 * • Tipo de Serviço (IFI, IFC, IPC)
 */

/**
 * Retorna os dados para tela vincula prognose com paginação
 * @param {number} PagNumber - Número da página
 * @param {number} PagSize - Tamanho da página
 * @param {string} FilteringWord - Palavra chave busca
 */
const getAllAplicaPrognose = async (PagNumber, PagSize, FilteringWord, filtros = {}) => {
	// filtros: { FazendasIds, TalhoesIds, EstratosIds } — listas de IDs dos dropdowns
	// (o CSV de fazendas/talhões é resolvido para IDs no cliente). Vazio = sem filtro.
	return treeviaGateway.post(
		'/ms-prognoses/vinculaprognose/dados-para-tela-vincula-prognose',
		{ PagNumber, PagSize, FilteringWord, ...filtros },
		{ timeout: 600000 },
	)
}

const getDropdownExportacaoProjecoes = async () => {
	return treeviaGateway.get('/ms-prognoses/exportacaodeprojecoes/dropdown-exportacao-projecoes')
}

const exportarANivelDeEstratoEInventarioFlorestal = async (idsPrognoseAplicada) => {
	return treeviaGateway.post(
		'/ms-prognoses/exportacaodeprojecoes/exportar-a-nivel-de-estrato-e-inventario-florestal',
		idsPrognoseAplicada,
	)
}

const exportarANivelDePlantio = async (idsPrognosePlantio) => {
	return treeviaGateway.post(
		'/ms-prognoses/exportacaodeprojecoes/exportar-a-nivel-de-plantio',
		idsPrognosePlantio,
	)
}

const especiesDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/especies')
}

const materialGeneticoDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/material-genetico')
}

const idadePlantioDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/idade-plantio')
}

const fazendasDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/fazendas')
}

const espacamentosDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/espacamentos')
}

const estratosDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/estratos')
}

const talhoesDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/talhoes')
}

/**
 * Opções de filtro da tela de Vincular: só fazendas/estratos/talhões que
 * existem no acervo PROCESSADO (elegível para vínculo), não o cadastro todo.
 * Resposta: { fazendas: [{id,nome,codigo}], estratos: [{id,codigo,descricao}],
 * talhoes: [{id,codigo,fazenda}] }
 */
const filtrosVincularDropdown = async () => {
	return registryApi.get('v1/vinculaprognose/filtros-para-vincular')
}

const getFiltrosDropdown = async () => {
	// Dropdowns em paralelo (antes eram awaits sequenciais somando latência).
	const [
		{ data: especies },
		{ data: materialGenetico },
		{ data: idadePlantio },
		{ data: fazendas },
		{ data: espacamentos },
		{ data: estratos },
	] = await Promise.all([
		especiesDropdown(),
		materialGeneticoDropdown(),
		idadePlantioDropdown(),
		fazendasDropdown(),
		espacamentosDropdown(),
		estratosDropdown(),
	])

	return {
		//datasPlantio: dataPlantio.result.map((d) => {
		//  return { value: d.id, label: d.descricao }
		//}),
		especies: especies.result,
		materiaisGeneticos: materialGenetico.result.map((d) => {
			return { value: d.id, label: d.descricao }
		}),
		idadesPlantio: idadePlantio.result.map((d) => {
			return { value: d.id, label: d.idade }
		}),
		fazendas: fazendas.result,
		espacamentos: espacamentos.result.map((d) => {
			return { value: d.id, label: d.descricao }
		}),
		estratos: estratos.result,
		//datasMedicao : datasMedicao.result
	}
}

const filterParcelasPrognose = async (params) => {
	const obterDataHoje = () => {
		const hoje = new Date()
		const ano = hoje.getFullYear()
		const mes = ('0' + (hoje.getMonth() + 1)).slice(-2) // +1 porque getMonth() retorna 0-11
		const dia = ('0' + hoje.getDate()).slice(-2)
		return ano + '-' + mes + '-' + dia
	}

	//tratamento de Data de Plantio para a busca da prognose
	if (params.datasPlantio[0] || params.datasPlantio[1]) {
		params.datasPlantio[0] = params.datasPlantio[0] ? params.datasPlantio[0] : '1500-01-01'
		params.datasPlantio[1] = params.datasPlantio[1] ? params.datasPlantio[1] : obterDataHoje()
	} else {
		params.datasPlantio = []
	}
	//tratamento de Data de Medição para a busca da prognose
	if (params.datasMedicao[0] || params.datasMedicao[1]) {
		params.datasMedicao[0] = params.datasMedicao[0] ? params.datasMedicao[0] : '1500-01-01'
		params.datasMedicao[1] = params.datasMedicao[1] ? params.datasMedicao[1] : obterDataHoje()
	} else {
		params.datasMedicao = []
	}

	return registryApi.post('v1/filtrocategoriaprognose/filtro-para-prognose', params)
}

// const sendProcessamento = async () => {
//   return modelosVariaveis
//   // return walterApi.post("/SiteClassificationModelAdjustment/SiteClassificationModels", { parcelas: body })
//   // return classificacaoSitioApi.post("/classificacaodesitiomodelos/gerar-modelos", { amostras: body })
// }

const chooseModel = async (body) => {
	// body = bodyModelChosen;
	return walterApi.post('/SiteClassificationModelAdjustment/SiteClassificationDefaultMethods', body)
}

const gerarModeloSemSitio = async (body) => {
	// body = bodyModelChosen;
	return prognoseApi.post('/prognosesmodelos/gerar-modelos-sem-sitio', body)
}

const gerarModeloComSitio = async (body) => {
	// body = bodyModelChosen;
	return prognoseApi.post('/prognosesmodelos/gerar-modelos', body)
}

const updatePrognose = async (body) => {
	return treeviaGateway.put('/ms-prognoses/prognose/editar-prognose', body)
}

/**
 * Processa a prognose orquestrado pelo back (fluxo D): o front manda APENAS o
 * filtro + variáveis (+ parametrização de sítio, quando houver). O Registry
 * busca as parcelas server-side, monta as amostras e chama o ApiGateway de
 * modelos. Evita trafegar centenas de MB pelo navegador (resolve o 413).
 *
 * @param {Object} body { filtro, variaveis: string[], parametrizacaoSitio: Object|null }
 */
const processarPrognosePorFiltro = async (body) => {
	return registryApi.post('v1/filtrocategoriaprognose/processar-prognose', body, {
		timeout: 600000,
	})
}

/**
 * Enfileira o processamento assíncrono da prognose (fluxo D + Service Bus). O
 * worker (Prognoses.API) busca os dados, ajusta os modelos em fidelidade total
 * e grava o resultado. Devolve { jobId } para polling.
 *
 * @param {Object} body { filtro, variaveis, parametrizacaoSitio, outliersExcluidos, pontosEsperados }
 */
const enfileirarProcessamentoPrognose = async (body) => {
	return treeviaGateway.post('/ms-prognoses/prognoseprocessamento/processar', body)
}

/**
 * Consulta o status/resultado de um job de processamento de prognose.
 * A resposta traz também o progresso (etapa, renderFeitos/renderTotal).
 * @param {string} jobId
 */
const statusProcessamentoPrognose = async (jobId) => {
	return treeviaGateway.get(`/ms-prognoses/prognoseprocessamento/processar/${jobId}`)
}

/**
 * Central de processamentos: jobs recentes do cliente (metadados + progresso,
 * sem o resultado — o resultado vem pelo status do job escolhido).
 * @param {number} quantidade
 */
const listarProcessamentosPrognose = async (quantidade = 20, tipo = null) => {
	// tipo (Processamento|Vinculo): cada central lista só o seu fluxo.
	const filtroTipo = tipo ? `&tipo=${tipo}` : ''
	return treeviaGateway.get(
		`/ms-prognoses/prognoseprocessamento/jobs?quantidade=${quantidade}${filtroTipo}`,
	)
}

/**
 * Contexto de um job (request original do processar, incl. o snapshot da tela)
 * — usado pela central para reabrir/retomar um job.
 * @param {string} jobId
 */
const contextoProcessamentoPrognose = async (jobId) => {
	return treeviaGateway.get(`/ms-prognoses/prognoseprocessamento/processar/${jobId}/contexto`)
}

/**
 * Remove um job da central (ex.: após salvar o planejamento). Idempotente.
 * @param {string} jobId
 */
const excluirProcessamentoPrognose = async (jobId) => {
	return treeviaGateway.delete(`/ms-prognoses/prognoseprocessamento/processar/${jobId}`)
}

export {
	//   filtraParcelas,
	getAllAplicaPrognose,
	fazendasDropdown,
	estratosDropdown,
	talhoesDropdown,
	filtrosVincularDropdown,
	getDropdownExportacaoProjecoes,
	exportarANivelDeEstratoEInventarioFlorestal,
	exportarANivelDePlantio,
	getFiltrosDropdown,
	filterParcelasPrognose,
	//   sendProcessamento,
	chooseModel,
	gerarModeloSemSitio,
	getPrognosePorId,
	gerarModeloComSitio,
	getAllPrognose,
	deletePrognoseByIdList,
	updatePrognose,
	processarPrognosePorFiltro,
	enfileirarProcessamentoPrognose,
	statusProcessamentoPrognose,
	listarProcessamentosPrognose,
	contextoProcessamentoPrognose,
	excluirProcessamentoPrognose,
}
